<template>
  <div class="row align-items-center" style="margin: 0 0.5rem;">
    <div class="col-xs-24 col-sm-12 col-md-4 col-lg-3 col-xl-3">
      <div class="row">
        <div class="col">
          <p class="mb-0 pulldown__title">原言語</p>
          <el-select
            v-model="selectedSourceLanguage" style="width: 100%;"
            @change="updateSourceLanguage"
          >
            <el-option
              v-for="language in languages"
              :key="language.code"
              :label="language.code"
              :value="language.code"
            >
            <span style="float: left">{{ language.code }}</span>
            <span
              style="
              float: right;
              color: var(--el-text-color-secondary);
              font-size: 13px;
              "
              >{{ language.name }}</span
            >
            </el-option>
          </el-select>
        </div>

        <div class="col">
          <p class="mb-0 pulldown__title">目的言語</p>
          <el-select
            v-model="selectedTargetLanguage"
            style="width: 100%;"
            @change="updateTargetLanguage"
          >
            <el-option
              v-for="language in languages"
              :key="language.code"
              :label="language.code"
              :value="language.code"
            >
            <span style="float: left">{{ language.code }}</span>
            <span
              style="
              float: right;
              color: var(--el-text-color-secondary);
              font-size: 13px;
              "
              >{{ language.name }}</span
            >
            </el-option>
          </el-select>
        </div>
      </div>

    </div>
    <div class="my-3 border-bottom d-md-none" style="max-width: 700px;"></div>

    <div class="col-xs-24 col-sm-12 col-md-8 offset-lg-1 col-xl-7 offset-xl-2">
      <div class="row">
        <div class="col-xs-24 col-md-6">
          <p class="mb-0 pulldown__title">AIモデル</p>
          <el-select v-model="selectedAimodel" style="width: 100%;" @change="updateAimodel">
            <el-option
              v-for="aimodel in this.aimodels"
              :key="aimodel.name"
              :label="aimodel.name"
              :value="aimodel.id"
            >
            </el-option>
          </el-select>
        </div>

        <div class="col-xs-24 col-md-6">
          <p class="mb-0 pulldown__title">用語集</p>
          <el-select v-model="selectedGlossary" style="width: 100%;" @change="updateGlossary">
            <el-option label="指定しない" value=""></el-option>
            <el-option
              v-for="glossary in this.glossaries"
              :key="glossary.name"
              :label="glossary.name"
              :value="glossary.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import { defineComponent } from "vue";
import { ElInput, ElSelect, ElOption } from 'element-plus';

export default defineComponent({
  name: "TranslationOptions",
  components: { 
    ElInput,
    ElSelect,
    ElOption,
  },
  data() {
    return {
      aimodels: [],
      glossaries: [],
      languages: [],
      selectedSourceLanguage: "英",
      selectedTargetLanguage: "日",
      selectedAimodel: "",
      selectedGlossary: "",
    };
  },
  props: {
    hypothesies: Object,
    permission: String,
  },

  created() {
    this.fetchLanguages();
  },

  methods: {
    async fetchLanguages() {
      try {
        const res = await axios.get('/get_languages');
        this.languages = res.data.languages;
        this.fetchTranslationResource();
      } catch (error) {
        console.error(error);
      }
    },
    async fetchTranslationResource() {
      try {
        const res = await axios.post('/fetch_translation_resources_by_lang', {
            src_language_code: this.selectedSourceLanguage,
            trg_language_code: this.selectedTargetLanguage,
        });
        this.aimodels = res.data.aimodels;
        this.glossaries = res.data.glossaries;

        if (this.aimodels.length==0){
          console.log("AIモデルを取得できません。ページを更新するか、チームが選択されているかを確認してください。");
          this.selectedAimodel = "";
        }else{
          this.selectedAimodel = this.aimodels[0].id;
        }

        this.selectedGlossary = "";

        console.log(this.selectedAimodel);
        console.log(this.selectedGlossary);
        this.emitOptions();
      } catch (error) {
        console.error(error);
      }
    },
    updateSourceLanguage() {
      if (this.selectedSourceLanguage === '英') {
        this.selectedTargetLanguage = '日';
      } else if (this.selectedSourceLanguage === '日') {
        this.selectedTargetLanguage = '英';
      }
      this.fetchTranslationResource();
    },
    updateTargetLanguage() {
      if (this.selectedTargetLanguage === '英') {
        this.selectedSourceLanguage = '日';
      } else if (this.selectedTargetLanguage === '日') {
        this.selectedSourceLanguage = '英';
      }
      this.fetchTranslationResource();
    },
    updateAimodel(){
      this.emitOptions();
    },
    updateGlossary(){
      console.log(this.selectedGlossary);
      this.emitOptions();
    },
    emitOptions(){
      this.$emit('update-value', {
        selectedSourceLanguage: this.selectedSourceLanguage,
        selectedTargetLanguage: this.selectedTargetLanguage,
        selectedAimodel: this.selectedAimodel,
        selectedGlossary: this.selectedGlossary,
      });
    },
    async updateTranslationResouces() {
      const response = await axios.post('/get_translation_resources', {
        src_language: this.selectedSourceLanguage,
        trg_language: this.selectedTargetLanguage
      });
      console.log(response.data.aimodels);
      this.$set(this, 'aimodels', response.data.aimodels);

      this.glossaries = response.data.glossaries;
    },





  }
});
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col-md-3 {
  flex: 0 0 25%;
  max-width: 25%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.pulldown__title {
  font-size: 0.7rem;
  margin-right: 1rem;
  margin-left: 0.1rem;
  color: #31443D;
}
</style>